var music = {};
module['exports'] = music;
music.genre = require("./genre");